import { render } from "./PostItem.vue?vue&type=template&id=136ac4ea&scoped=true"
import script from "./PostItem.vue?vue&type=script&lang=js"
export * from "./PostItem.vue?vue&type=script&lang=js"

import "./PostItem.vue?vue&type=style&index=0&id=136ac4ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136ac4ea"]])

export default __exports__